import * as React from 'react'
import { styled } from 'styled-components'

const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const PriceValue = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  line-height: 1.2;
  color: var(--bs-body-bg);
`

const TaxInfo = styled.div`
  font-size: 0.8rem;
  color: var(--bs-body-bg);
  opacity: 0.6;
`

export interface PriceDisplayProps {
  totalPrice: number
  taxRate?: number
  className?: string
}

export const PriceDisplay: React.FC<PriceDisplayProps> = ({ totalPrice, taxRate = 19, className }) => {
  const formattedPrice = totalPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const taxAmount = ((totalPrice * taxRate) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  return (
    <PriceContainer className={className}>
      <div>
        <PriceValue>€ {formattedPrice}</PriceValue>
        <TaxInfo>inkl. MwSt. (€ {taxAmount})</TaxInfo>
      </div>
    </PriceContainer>
  )
}
